import "@sphtech/dmg-design-system/dist/theme-hbs.css";
import "@sphtech/dmg-design-system/assets/hbs/fonts.css";

import Newsticker from "@components/Modules/Newsticker/Newsticker";
import { configHome, configSite } from "@pub/config";
import { BaseLayout } from "@sphtech/dmg-design-system";
import { useLocation } from "react-router";

import { configHeader } from "./config/configHeader";
import logo25AnniversarySvgSource from "./logo-25-anniversary.svg?raw";
import { RoutePaths } from "./routePaths";

type HBSBaseLayoutProps = {
  ArticleTitle?: string;
  children: React.ReactNode;
  ads?: boolean;
  leaderboard?: boolean;
  skipMobileBanner?: boolean;
};

/**
 * Reusable Base layout specific to HBS.
 */
const HBSBaseLayout = ({
  ArticleTitle,
  children,
  ads = true,
  leaderboard = true,
  skipMobileBanner,
}: HBSBaseLayoutProps) => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  return (
    <BaseLayout
      ArticleTitle={ArticleTitle}
      ads={ads}
      leaderboard={leaderboard}
      NewsTicker={<Newsticker />}
      RoutePaths={RoutePaths}
      svgSource={logo25AnniversarySvgSource}
      siteName={configSite.name}
      mciText={
        <span suppressHydrationWarning>
          MDDI (P) 003/11/2025. Published by SPH Media Limited, Co. Regn. No.
          202120748H. Copyright © {currentYear} SPH Media Limited. All rights
          reserved.
        </span>
      }
      socialIconProps={configHeader.socialMedia}
      megaMenuProps={{
        NewsLetterProps: configHeader.megaMenu.newsletter,
        CloseButtonProps: configHeader.megaMenu.closeButton,
      }}
      subscribeBoxButtonIcon={configHome.magazineListing?.ctaIcon}
      skipMobileBanner={skipMobileBanner}
      currentLocation={location}
    >
      {children}
    </BaseLayout>
  );
};

export default HBSBaseLayout;
